import { render, staticRenderFns } from "./ResetLinkLayout.vue?vue&type=template&id=36a2f89c&"
import script from "./ResetLinkLayout.vue?vue&type=script&lang=js&"
export * from "./ResetLinkLayout.vue?vue&type=script&lang=js&"
import style0 from "./ResetLinkLayout.vue?vue&type=style&index=0&id=36a2f89c&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/forge/branch.goz.fun/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('36a2f89c')) {
      api.createRecord('36a2f89c', component.options)
    } else {
      api.reload('36a2f89c', component.options)
    }
    module.hot.accept("./ResetLinkLayout.vue?vue&type=template&id=36a2f89c&", function () {
      api.rerender('36a2f89c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/Layouts/ResetLinkLayout.vue"
export default component.exports